export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#0e86d4",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#0e86d4",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "#000080",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#0e86d4",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#0e86d4",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "#000080",
};
